import { useCallback, useEffect, useState } from "react";
import { PartialCreateCampaignInquiryInput } from "src/components/CreateCampaignInquiryForm/utils";
import { useDuplications } from "src/hooks/files/useInquiryImageDuplication";

import { CreateCampaignInquiryLayout } from "../CreateCampaignInquiryLayout";

interface CampaignInquiryDuplicationTemplateProps {
    initialValues?: PartialCreateCampaignInquiryInput;
    isLoading?: boolean;
}

export const CampaignInquiryDuplicationTemplate = ({
    initialValues,
    isLoading,
}: CampaignInquiryDuplicationTemplateProps) => {
    const [inquiryData, setInquiryData] = useState<PartialCreateCampaignInquiryInput | undefined>(initialValues);
    const [isDuplicatingImage, setIsDuplicatingImage] = useState(!!inquiryData);
    const { createDuplicateCampaignInquiryImages } = useDuplications();

    const createDuplicateImages = useCallback(async () => {
        if (!initialValues) {
            return;
        }

        setIsDuplicatingImage(true);
        const duplicatedInitialData = await createDuplicateCampaignInquiryImages(initialValues);
        setInquiryData(duplicatedInitialData);
        setIsDuplicatingImage(false);
    }, [createDuplicateCampaignInquiryImages, initialValues]);

    useEffect(() => {
        if (initialValues) {
            createDuplicateImages();
        }
    }, [createDuplicateImages, initialValues]);

    return (
        <CreateCampaignInquiryLayout
            key={isDuplicatingImage ? "duplicating" : "not-duplicating"}
            initialValues={inquiryData}
            isLoading={isDuplicatingImage || isLoading}
        />
    );
};
